<mat-card>
  <mat-card-header>
    <mat-card-title>Workflow Summary</mat-card-title>
    <mat-card-subtitle>Review your workflow before saving.</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <!-- Definition -->
    <section>
      <h3>Definition</h3>
      <div class="item">
        <span class="label">Name:</span>
        <span>{{ workflow.details?.name }}</span>
      </div>

      <div class="item">
        <span class="label">Description:</span>
        <span>{{ workflow.details?.description }}</span>
      </div>

      <!-- Keywords -->
      <div class="item">
        <span class="label">Keywords:</span>
        @if (workflow.details?.keywords && workflow.details?.keywords!.length > 0) {
          <div class="chips-container">
            <mat-chip-set>
              @for (keyword of workflow.details?.keywords; track keyword) {
                <mat-chip>{{ keyword }}</mat-chip>
              }
            </mat-chip-set>
          </div>
        } @else {
          <span>No keywords added</span>
        }
      </div>

      <!-- Sensitivity Labels -->
      <div class="item">
        <span class="label">Sensitivity Labels</span>
        @if (workflow.details?.sensitivityLabels && workflow.details?.sensitivityLabels!.length > 0) {
          <ul>
            @for (label of workflow.details?.sensitivityLabels; track label) {
              <li>
                <span>{{ agentService.getSensitivityLabelString(label) }}</span>
              </li>
            }
          </ul>
        }
      </div>
    </section>

    <section>
      <h3>Instructions</h3>
      <div class="item">
        <ol>
          @for (instructionId of workflow.details?.instructions; track instructionId) {
            <li>
              <span>{{ getInstruction(instructionId)?.details!.name }}</span>
            </li>
          }
        </ol>
      </div>
    </section>

    <section>
      <h3>Security</h3>
      <div class="item">
        <span class="label">Owners</span>
        <ul>
          @for (owner of workflow.details?.owners; track owner) {
            <li>
              <span>{{ owner.name }}</span>
            </li>
          }
        </ul>

        <div class="label">Users</div>
        @if (workflow.details?.users && workflow.details?.users!.length > 0) {
          <ul>
            @for (user of workflow.details?.users; track user) {
              <li>
                <span>{{ user.name }}</span>
              </li>
            }
          </ul>
        } @else {
          <span class="none">No users added</span>
        }

        <div class="label">Groups</div>
        @if (workflow.details?.groups && workflow.details?.groups!.length > 0) {
          <ul>
            @for (group of workflow.details?.groups; track group) {
              <li>
                <span>{{ group.displayName }}</span>
              </li>
            }
          </ul>
        } @else {
          <span class="none">No groups added</span>
        }
      </div>
    </section>

    <section>
      <h3>Admin</h3>
      <div class="item">
        <span class="label">Enabled:</span>
        @let enabledText = workflow.details?.isEnabled ? 'Yes' : 'No';
        <span>{{ enabledText }}</span>
      </div>

      <div class="item">
        <span class="label">Universal:</span>
        @let universalText = workflow.details?.isUniversal ? 'Yes' : 'No';
        <span>{{ universalText }}</span>
      </div>
    </section>
  </mat-card-content>
</mat-card>
